<template>
  <div class="_component-button" :class="componentClassObj" @click.prevent="handleClick">
    <div class="button-content">
      <slot></slot>
      <div class="sub-text" v-if="subText">{{ subText }}</div>
    </div>
  </div>
</template>
<script>
import Basic from '../Basic';
/**
 * @module Button 按钮
 */
export default {
  name: 'Button',
  extends: Basic,
  /**
   * @prop {string} [skin='red'] 按钮颜色
   */
  props: {
    skin: {
      type: String,
      default: 'red'
    },
    auto: {
      type: Boolean,
      default: false
    },
    subText: {
      type: String,
      default: ''
    }
  },
  computed: {
    isFormError() {
      let ret = false;
      if (this.extendFromForm && this.auto) {
        ret = this.$form.hasError;
      }
      return ret;
    },
    isDisabled() {
      return this.isFormError || this.disabled;
    },
    componentClassObj() {
      let ret = {
        error: this.isError,
        disabled: this.isDisabled,
        focus: this.focus,
        formed: this.isFormed,
        'no-label': !this.label,
        'sub-text': !!this.subText
      };
      if (this.size) {
        ret[`size-${this.size}`] = true;
      }
      if (this.skin) {
        ret[`skin-${this.skin}`] = true;
      }
      if (this.type) {
        ret[`type-${this.type}`] = true;
      }
      return ret;
    }
  },
  methods: {
    /**
     * @description 按钮点击事件
     * @param {object} e 点击事件对象
     */
    handleClick(e) {
      if (!this.isAllowDisabledEvents && this.isDisabled) {
        return;
      } else {
        if (this.extendFromForm && this.type === 'submit') {
          this.$form.submit();
        } else if (this.extendFromForm && this.type === 'save') {
          this.$form.save();
        } else {
          this.$emit('click', e);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
